import {
  ActionProcessMode,
  IContextMenuItemRefreshRules,
} from '@infotech-soe/metaschema';

import { ClientContext } from '../../context/IContextService';
import { CommandName } from '../CommandViewModel';
import { UserInteractor, UserInteractorType } from '../UserInteractor';

import CategoryCommandImpl from './CategoryCommandImpl';

class FileLinkRecordCommandImpl extends CategoryCommandImpl<
  Record<string, any>
> {
  constructor(private refreshRules?: IContextMenuItemRefreshRules) {
    super();
  }

  public async execute(): Promise<void> {
    return;
  }

  public getUserInteractor(): UserInteractor {
    return {
      type: UserInteractorType.DICTIONARY,
      multiSelect: false,
    };
  }

  public async getInitialArgs(
    context: ClientContext
  ): Promise<Record<string, any>> {
    return {
      fileLinks: true,
      cndCategory: context.get('Category'),
      cndRecordId: context.get('Id'),
    };
  }

  public getName(): CommandName {
    return 'fileLink';
  }

  public getRefreshRules(): IContextMenuItemRefreshRules | undefined {
    return this.refreshRules;
  }

  public getProcessMode(): ActionProcessMode {
    return 'Current';
  }
}

export default FileLinkRecordCommandImpl;
